export default __webpack_public_path__ + "static/4-dc88d96d0ddae5f5c5be313a9bdb1e8f.png";